<template>
    <div class="common-dialog" :style="{'position':'relative','z-index':zIndex}">
        <el-dialog
        :title="title"
        :visible.sync="show"
        :show-close="showClose"
        :close-on-click-modal="closeOnClickModal"
        :close-on-press-escape="closeOnPressEscape"
        :width="width"
        custom-class="MyDialog">
            <div class="dialog-content">
                <div class="content">
                    <div v-html="contentText">
                    </div>
                </div>
            </div>
            <div slot="footer" v-if="showFooter">
                <div class="right" v-if="footerType == 'right'">
                    <template v-if="cancleText">
                        <el-button round @click="cancleCallback">
                            {{ cancleText }}
                        </el-button>
                    </template>
                    <template v-if="confirmText">
                        <el-button round type="primary" @click="confirmCallback">
                            {{ confirmText }}
                        </el-button>
                    </template>
                </div>
                <div class="center" v-else>
                    <el-button round type="primary" @click="confirmCallback">
                        {{ confirmText }}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: true,
            width:"50vw",
            footerType:'center',
            title:"title",
            showFooter:true,
            cancleText: this.$t('app.auto_709_b58a2367'),
            confirmText: this.$t('app.auto_710_064217c6'),
            showClose:true,
            closeOnClickModal:true,
            closeOnPressEscape:true,
            zIndex:2001,
            contentText:``,
        }
    },
}
</script>

<style lang="scss" scoped>
.common-dialog{
    position: relative;
    z-index: 3001;
    .dialog-content{
        font-size: 16px;
    }
    .center{
        text-align: center;
    }
    .content{
        font-size: 16px;
        color: #000;
        line-height: 24px;
    }
    :deep(.el-button--primary){
        border-color: #3192f1;
        background-color: #3192f1;
    }
}
</style>